import { render } from "./LicensePrompt.vue?vue&type=template&id=0d97626a&scoped=true&ts=true"
import script from "./LicensePrompt.vue?vue&type=script&lang=ts"
export * from "./LicensePrompt.vue?vue&type=script&lang=ts"

import "./LicensePrompt.vue?vue&type=style&index=0&id=0d97626a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d97626a"]])

export default __exports__